import { ReactNode } from "react";
import { Article } from "@/typings/article";
import { formatDate } from "@/utils/news";
import styles from "@/pages/index.module.css";

interface NewsArticleProps {
  article: Article;
}

export function NewsArticle({ article }: NewsArticleProps): ReactNode {
  return (
    <article>
      <h2>{article.title}</h2>
      <time className={styles.newsArticleDate} dateTime={article.date}>
        {formatDate(article.date)}
      </time>
      {article.content}
    </article>
  );
}
